import { Navigation, Phone, MessageCircle } from "lucide-react";
import { site } from "../config/siteConfig";

export const MapBlock = () => (
  <div data-testid="map-block" className="space-y-4">
    <div className="overflow-hidden rounded-3xl border border-brand-line shadow-sm">
      <iframe
        title="Map showing the location of Ansar Public School in Mundeke Goraya, Daska"
        src={site.mapEmbedUrl}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="h-[320px] w-full sm:h-[400px]"
        allowFullScreen
      />
    </div>
    <div className="flex flex-wrap gap-3">
      <a
        href={site.directionsUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="map-directions-button"
        className="inline-flex min-h-[44px] items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
      >
        <Navigation className="h-4 w-4" aria-hidden="true" /> Get Directions
      </a>
      <a
        href={site.phoneHref}
        data-testid="map-call-button"
        className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-brand bg-white px-5 py-2.5 text-sm font-semibold text-brand transition-colors hover:bg-brand-light focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
      >
        <Phone className="h-4 w-4" aria-hidden="true" /> Call the School
      </a>
      <a
        href={site.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="map-whatsapp-button"
        className="inline-flex min-h-[44px] items-center gap-2 rounded-full border border-brand-green bg-white px-5 py-2.5 text-sm font-semibold text-brand-green transition-colors hover:bg-green-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-green"
      >
        <MessageCircle className="h-4 w-4" aria-hidden="true" /> WhatsApp
      </a>
    </div>
  </div>
);
